import { User } from 'model';
import isEmail from 'validator/lib/isEmail';
import { FormValidationRules } from '../hooks/useFormValues';

export const UserEditRules: FormValidationRules<User> = {
	username: {
		rules: {
			required: {
				value: true,
				message: 'Username is required'
			}
		}
	},
	description: {
		rules: {
			required: {
				value: true,
				message: 'Description is required'
			}
		}
	},
	email: {
		rules: {
			required: {
				value: true,
				message: 'Email is required'
			},
			func: {
				value: (value: string) => value === '' || isEmail(value),
				message: 'Incorrectly formatted email'
			}
		}
	}
};
